import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import IntroTopSection from '../../../components/Introduction/IntroTopSection';
import IntroSubHeading from '../../../components/Introduction/IntroSubHeading';
import { FiEye, FiAlertCircle } from 'react-icons/fi';
import { HomeService } from "../../../services";
import arrowLeft from '../../../assets/img/icon/arrow-left.svg';
import arrowRight from '../../../assets/img/icon/arrow-right.svg';
import { formatDateToYYYYMMDD } from '../../../utils/dateUtils';

function GalleryDetailsPC() {
  const navigate = useNavigate();
  const [announcementDetail, setAnnouncementDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  const fetchAnnouncementData = async () => {
    try {
      setLoading(true);
      const apiData = await HomeService.getGalleryDetails(id);
      setAnnouncementDetail(apiData);

      // if (apiData && apiData.current) {
      //     // Ensure previous and next fields are properly set
      //     apiData.previous = apiData.previous || null;
      //     apiData.next = apiData.next || null;

      //     setAnnouncementDetail(apiData);
      // } else {
      //     setError('공지사항을 찾을 수 없습니다.');
      // }
    } catch (err) {
      console.error('Failed to fetch announcements:', err);
      setError('공지사항 데이터를 불러오는데 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  // Simulate API call
  useEffect(() => {
    fetchAnnouncementData();
  }, [id]);


  const handleNavigationClick = (direction) => {
    if (!announcementDetail) return;

    const id = direction === 'prev' ? announcementDetail.prevId : announcementDetail.nextId;

    if (id) {
      // Set loading state for better UX
      setLoading(true);
      // Navigate to the previous/next article
      navigate(`/memorial-gallery-details/${id}`);
    }
  };


  return (
    <div className="announcement-list-page intro-info-page">

      <IntroTopSection />

      {/* Main Content */}
      <main className="main-content">
        <IntroSubHeading heading="추모원 갤러리" />

        {/* Announcement Details Section */}
        {loading ? (
          <section className="announcement-details-section">
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>공지사항을 불러오는 중...</p>
            </div>
          </section>
        ) : error ? (
          <section className="announcement-details-section">
            <div className="error-container">
              <FiAlertCircle size={48} className="error-icon" />
              <p>{error}</p>
              <button
                className="retry-button"
                onClick={() => window.location.reload()}
              >
                다시 시도
              </button>
            </div>
          </section>
        ) : announcementDetail ? (
          <>
            <section className="announcement-details-section">
              {/* Article Header */}
              <div className="article-header">
                <h2 className="article-title">{announcementDetail.galleryTitle}</h2>
                <div className="article-meta">
                  <span className="article-date">{formatDateToYYYYMMDD(announcementDetail.registTime)}</span>
                  <div className="article-views">
                    <FiEye size={14} className="eye-icon" />
                    <span>{announcementDetail.readCount}</span>
                  </div>
                </div>
              </div>

              <div className="divider"></div>

              {/* Article Content */}
              {/* <div className="article-content">
                {announcementDetail.photoThumbUrl && (
                  <div className="article-image">
                    <div className="content-image-placeholder">
                      <img src={announcementDetail.photoThumbUrl} alt="announcement-image" />
                    </div>
                  </div>
                )}
              </div> */}

              <div className="article-content">

                {announcementDetail.attachments && announcementDetail.attachments.length > 0 ? (
                  <div className="article-image">
                    {announcementDetail.attachments.map((img, index) => (
                      <div className="content-image-placeholder" key={index}>
                        <img src={img} alt={`gallery-image-${index}`} />
                      </div>
                    ))}
                  </div>
                ) : (

                  announcementDetail.photoThumbUrl && (
                    <div className="article-image">
                      <div className="content-image-placeholder">
                        <img
                          src={announcementDetail.photoThumbUrl}
                          alt="announcement-image"
                        />
                      </div>
                    </div>
                  )
                )}
              </div>



              {/* List Button */}
              <div className="list-button-container gallery-details-list-button-container">

                <div className="list-button-container-wrapper">
                  <button
                    className={`list-button memorial-gallery-list-button-black ${!announcementDetail.prevId ? 'disabled' : ''}`}
                    onClick={() => handleNavigationClick('prev')}
                  >
                    이전글
                  </button>
                  <button
                    className={`list-button memorial-gallery-list-button-black ${!announcementDetail.nextId ? 'disabled' : ''}`}
                    onClick={() => handleNavigationClick('next')}
                  >
                    다음글
                  </button>
                </div>
                <button
                  className="list-button memorial-gallery-list-button"
                  onClick={() => navigate('/memorial-gallery-list')}
                >
                   목록 
                  {/* 뒤로가기 */}
                </button>
              </div>
            </section>


          </>
        ) : null}


      </main>

    </div>
  );
}

export default GalleryDetailsPC; 